export default {
  // 2-1
  factory_list: [],
  workarea_list: [],
  reason_list: [],
  manager_list: [],
  signer_list: [],
  worktype_list: [],
  cardValid: "", // 發卡狀態
  idValid: "", // 證號輸入
};
